import React from 'react';

const LegendItemPlaceholder = () => {
  return (
    <div className="legend-group">
      <div className="text__placeholder--medium shimmer" />
      {Array.from({ length: 3 }, (_, i) => (
        <div
          key={`legend-list__item-placeholder${i}`}
          className="legend-list__item-placeholder"
        >
          <div className="square__placeholder shimmer" />
          <div className="text__placeholder--small shimmer" />
        </div>
      ))}
    </div>
  );
};

export default LegendItemPlaceholder;
